import React from 'react'
import 'less/controls/tabs.less'

const Tabs = ({ tabs, onClick, className }) => (
  <div className={className}>
    {tabs.map(({ display, active, value, title = '' }, index) => (
      <a
        tabIndex={index}
        key={index}
        onClick={(...args) => onClick(value, ...args)}
        className={`tab ${active ? 'active' : ''} ${value==='info'? value : value==='chat' ? value : ''}`}
        title={title}
      >
        {display}
      </a>
    ))}
  </div>
)

export default Tabs
